import { render, staticRenderFns } from "./password-setting.vue?vue&type=template&id=2cca22db"
import script from "./password-setting.vue?vue&type=script&lang=js"
export * from "./password-setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports